<template lang="pug">
  .room.anchor-room(v-loading="loadingData")
    .divice-block-multi
      .divice-block(:class="warningFlag1")
        .divice-block-1
          DoubleGraph(:opts="humidity1" :series="humidity1Data")
        .divice-block-2
          SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" )
      .divice-block(:class="warningFlag2")
        .divice-block-1
          DoubleGraph(:opts="humidity2" :series="humidity2Data")
        .divice-block-2
          SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" )
    .divice-block-line
      .divice-block-line-item.divice-block-line-item-col1
        single-histogram.divice-block-multi-item(:opts="singleHisOpts" :series="airPrepPower" :class="warningFlag3")
      .divice-block-line-item.divice-block-line-item-col
        .divice-block-line-item-col-top
          .divice-block-line-item-col-top-in
            SwitchStatus.divice-block-thin(title="风机1运行" :series="SwitchStatusData1")
            SwitchStatus.divice-block-thin(title="风机1故障" :series="SwitchStatusData2")
            RunningTimeBig.divice-block-time(title="风机1运行时间" :series="RunningTimeData1")
          .divice-block-line-item-col-top-in
            SwitchStatus.divice-block-thin(title="风机2运行" :series="SwitchStatusData3")
            SwitchStatus.divice-block-thin(title="风机2故障" :series="SwitchStatusData4")
            RunningTimeBig.divice-block-time(title="风机2运行时间" :series="RunningTimeData2")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/anchorAfan_data.json'

export default {
  name: 'anchorAfan',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      deviceList: [],
      diagramSeries: [],
      diagramStatus: 'Error',
      diagramLegendData: ['前锚', '后锚'],
      humidity1: {
        title: '前锚温湿度',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity1Data: null,
      humidity2: {
        title: '后锚温湿度',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity2Data: null,
      airPrepPower: {},
      singleHisOpts: {
        title: '1#空气制备站总功率',
        histogramName1: 'P',
        max: 30000,
        sign: 'W'
      },
      RunningTimeData1: null,
      RunningTimeData2: null,
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SwitchStatusData3: null,
      SwitchStatusData4: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapOpts1: {
        title: '前锚温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts2: {
        title: '后锚温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  created() {
    this.setTitles()
  },
  mounted() {
    this.getDatas()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName = nizhouConfigJSON[routerPath[1]].deviceName
      this.$set(this.singleHisOpts, 'title', deviceName[0])
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    GetDeviceData (id) {
      return this.$http.get('/statistics/DeviceData?deviceId=' + id + '&interval=BY_HOUR&insertBlankData=true')
    },
    getLineDatas () {
      const routerPath = this.$route.name.split('_')
      const deviceDataName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const that = this
      this.$http.all([this.GetDeviceData(this.findDeviceId(deviceDataName[0])), this.GetDeviceData(this.findDeviceId(deviceDataName[1]))])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity1Data', that, 'warningFlag1')
          })
        )
      this.$http.all([this.GetDeviceData(this.findDeviceId(deviceDataName[2])), this.GetDeviceData(this.findDeviceId(deviceDataName[3]))])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity2Data', that, 'warningFlag2')
          })
        )
    },
    getDatas() {
      this.getLineDatas()
      const routerPath = this.$route.name.split('_')
      const deviceDataName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/deviceData/Station?stationId=${stationId}`).then(res => {
        this.loadingData = false
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData1',
          this.findDeviceId(deviceDataName[0]),
          this.findDeviceId(deviceDataName[1]),
          'warningFlag1'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData2',
          this.findDeviceId(deviceDataName[2]),
          this.findDeviceId(deviceDataName[3]),
          'warningFlag2'
        )
        this.airPrepPower = {
          data: this.findDeviceData(__data, deviceDataName[4]).value
        }
        this.warningFlag3 = this.findDeviceData(__data, deviceDataName[4]).errorLevel
        this.SwitchStatusData1 = {
          data: __data[this.findDeviceId(deviceDataName[5])].value,
          isError: __data[this.findDeviceId(deviceDataName[6])].errorLevel
        }
        this.SwitchStatusData2 = {
          data: __data[this.findDeviceId(deviceDataName[7])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[8])].errorLevel
        }
        this.SwitchStatusData3 = {
          data: __data[this.findDeviceId(deviceDataName[9])].value,
          isError: __data[this.findDeviceId(deviceDataName[10])].errorLevel
        }
        this.SwitchStatusData4 = {
          data: __data[this.findDeviceId(deviceDataName[11])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[12])].errorLevel
        }
        this.RunningTimeData1 =
          __data[this.findDeviceId(deviceDataName[13])].value
        this.RunningTimeData2 =
          __data[this.findDeviceId(deviceDataName[14])].value
      })
    },
    dealData (res1, res2, name, that, warnName) {
      const __data = {}
      const __data1 = {}
      const _list1 = res1.data.dataList // .splice(-10)
      _list1.forEach((el, index) => {
        __data[el.dataDate] = el.value
      })
      const _list2 = res2.data.dataList // .splice(-10)
      _list2.forEach((el, index) => {
        __data1[el.dataDate] = el.value
      })
      that[name] = {
        data1: __data,
        data2: __data1
      }
      if (res1.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res1.data.errorLevel
      }
      if (res2.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res2.data.errorLevel
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.anchor-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
    .divice-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;
    }
    .divice-block-1 {
      width: 75%;
      height: 100%;
    }
    .divice-block-2 {
      width: 24%;
      height: 100%;
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      .divice-block-multi-item {
        width: calc(50% - 7px);
      }
    }
    .divice-block-line-item-col1 {
      width: calc(100% / 3 - 8px);
      .divice-block-multi-item {
        width: 100%;
      }
    }
    .divice-block-line-item-col {
      width: calc(100% / 3 * 2 - 8px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-top {
        display: flex;
        justify-content: space-between;
        height: 100%;
        &-in {
          display: flex;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
  .air-diagram {
    width: 50%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
  }

  .divice-block-thin {
    height: 42px;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .divice-block-time {
    height: calc(100% - 110px);
    width: 100%;
    box-sizing: border-box;
  }
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
}
</style>
